import clsx from "clsx";
import { FormattedMessage } from "react-intl";
import PublicIcon from "@mui/icons-material/Public";
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Icon,
  Radio,
  RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import DraggableModalBody from "../../../../common/DraggableModal/DraggableModalBody";
import DraggableModalHead from "../../../../common/DraggableModal/DraggableModalHead";
import DraggableModal from "../../../../common/DraggableModal";

const useStyles = makeStyles(theme => ({
  modal: {
    maxWidth: "450px !important",
    minWidth: "350px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  body: {
    padding: 0,
    minHeight: "10vh",
  },
  container: {
    padding: 20,
  },
  icon: {
    width: "50px",
    height: "50px",
    background: "#e4e6eb",
    borderRadius: "100%",
    display: " inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
    fontSize: "20px",
    cursor: "pointer",
  },
  fieldset: {
    width: "100%",
  },
}));

const PrivacySettingsModal = ({
  onChange,
  onClose,
  open,
  options,
  title,
  value,
}) => {
  const classes = useStyles();

  return (
    <DraggableModal
      customClass={classes.modal}
      handleClose={onClose}
      open={open}
    >
      <DraggableModalHead
        handleClose={onClose}
        title={title || <FormattedMessage id="settings.selectAudience" />}
      />
      <DraggableModalBody customClass={classes.body}>
        <Grid container className={classes.container} alignItems="center">
          <FormControl component="fieldset" className={classes.fieldset}>
            <RadioGroup
              aria-label="Visibility settings"
              onChange={e => onChange(e.target.value)}
              sx={{
                gap: "20px",
                "& :hover": {
                  background: "#e4e6eb",
                },
                "& .MuiRadio-root": {
                  minHeight: "50px",
                },
                "& .MuiFormControlLabel-root": {
                  alignItems: "flex-start",
                  marginLeft: 0,
                  marginRight: 0,
                },
                "& .MuiFormControlLabel-label": {
                  display: "inline-flex",
                  flexDirection: "column",
                  width: "100%",
                },
              }}
              value={value}
            >
              {options.map((item, index) => {
                const { description, name, value } = item;
                const icon = (
                  value === "PUBLIC"
                    ? <span className={classes.icon}><PublicIcon /></span>
                    : <Icon className={clsx(["fas fa-lock", classes.icon])} />
                );

                return (
                  <FormControlLabel
                    control={<Radio />}
                    key={index}
                    label={
                      <>
                        <Box component="span"
                          sx={{
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <span>{icon}</span>
                          <span>{name}</span>
                        </Box>
                        <Box component="span" style={{ marginLeft: "60px" }}>
                          <i>{description}</i>
                        </Box>
                      </>
                    }
                    labelPlacement="start"
                    value={value}
                  />
                );
              })}                
            </RadioGroup>
          </FormControl>
        </Grid>
      </DraggableModalBody>
    </DraggableModal>
  );
};

export default PrivacySettingsModal;
